export default "/assets/images/hw-carbon.f11d65a2e0d6abff.png";